module.exports = __webpack_public_path__ + "img/left_ellipse.1c6d7ff4.svg";